module.exports = __webpack_public_path__ + "img/usecase_enterprise_07.a5a16141.jpg";